import { MarkerColors } from "./enums"

// export default class MarkerUtils extends Vue {
export default class MarkerUtils {
    constructor(
        contentServiceUrl: string,
        timestamp: string) {
            this.contentServiceUrl = contentServiceUrl
            this.timestamp = timestamp
        }

    contentServiceUrl: string
    timestamp: string

    private darkRedMarker: string = ""
    public createDarkRedMarker(): string {
        if (this.darkRedMarker === "") {
            this.darkRedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri9E003B.svg" + "?" + this.timestamp
        }
        return this.darkRedMarker
    }

    private redMarker: string = ""
    public createRedMarker(): string {
        if (this.redMarker === "") {
            this.redMarker = this.contentServiceUrl + "/Content/icons/svg/markkeriE90008.svg" + "?" + this.timestamp
        }
        return this.redMarker
    }

    private turquoiseMarker: string = ""
    public createTurquoiseMarker(): string {
        if (this.turquoiseMarker === "") {
            this.turquoiseMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri026273.svg" + "?" + this.timestamp
        }
        return this.turquoiseMarker
    }

    private lightTurquoiseMarker: string = ""
    public createLightTurquoiseMarker(): string {
        if (this.lightTurquoiseMarker === "") {
            this.lightTurquoiseMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri00A2A5.svg" + "?" + this.timestamp
        }
        return this.lightTurquoiseMarker
    }

    private darkBlueMarker: string = ""
    public createDarkBlueMarker(): string {
        if (this.darkBlueMarker === "") {
            this.darkBlueMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri002C74.svg" + "?" + this.timestamp
        }
        return this.darkBlueMarker
    }

    private blueMarker: string = ""
    public createBlueMarker(): string {
        if (this.blueMarker === "") {
            this.blueMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri0058B1.svg" + "?" + this.timestamp
        }
        return this.blueMarker
    }

    private lightBlueMarker: string = ""
    public createLightBlueMarker(): string {
        if (this.lightBlueMarker === "") {
            this.lightBlueMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri008DE3.svg" + "?" + this.timestamp
        }
        return this.lightBlueMarker
    }

    private greenMarker: string = ""
    public createGreenMarker(): string {
        if (this.greenMarker === "") {
            this.greenMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri056805.svg" + "?" + this.timestamp
        }
        return this.greenMarker
    }

    private pinkMarker: string = ""
    public createPinkMarker(): string {
        if (this.pinkMarker === "") {
            this.pinkMarker = this.contentServiceUrl + "/Content/icons/svg/markkeriC50084.svg" + "?" + this.timestamp
        }
        return this.pinkMarker
    }

    private greyMarker: string = ""
    public createGreyMarker(): string {
        if (this.greyMarker === "") {
            this.greyMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri555555.svg" + "?" + this.timestamp
        }
        return this.greyMarker
    }

    private grayMarker: string = ""
    public createGrayMarker(): string {
        if (this.grayMarker === "") {
            this.grayMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri056805.svg" + "?" + this.timestamp
        }
        return this.grayMarker
    }

    private blackMarker: string = ""
    public createBlackMarker(): string {
        if (this.blackMarker === "") {
            this.blackMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri464646.svg" + "?" + this.timestamp
        }
        return this.blackMarker
    }

    private darkBlackMarker: string = ""
    public createDarkBlackMarker(): string {
        if (this.darkBlackMarker === "") {
            this.darkBlackMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_musta.svg" + "?" + this.timestamp
        }
        return this.darkBlackMarker
    }

    private purpleMarker: string = ""
    public createPurpleMarker(): string {
        if (this.purpleMarker === "") {
            this.purpleMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri820084.svg" + "?" + this.timestamp
        }
        return this.purpleMarker
    }

    private darkRedSelectedMarker: string = ""
    public createDarkRedSelectedMarker(): string {
        if (this.darkRedSelectedMarker === "") {
            this.darkRedSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_9E003B.svg" + "?" + this.timestamp
        }
        return this.darkRedSelectedMarker
    }

    private redSelectedMarker: string = ""
    public createRedSelectedMarker(): string {
        if (this.redSelectedMarker === "") {
            this.redSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_E90008.svg" + "?" + this.timestamp
        }
        return this.redSelectedMarker
    }

    private turquoiseSelectedMarker: string = ""
    public createTurquoiseSelectedMarker(): string {
        if (this.turquoiseSelectedMarker === "") {
            this.turquoiseSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_026273.svg" + "?" + this.timestamp
        }
        return this.turquoiseSelectedMarker
    }

    private lightTurquoiseSelectedMarker: string = ""
    public createLightTurquoiseSelectedMarker(): string {
        if (this.lightTurquoiseSelectedMarker === "") {
            this.lightTurquoiseSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_00A2A5.svg" + "?" + this.timestamp
        }
        return this.lightTurquoiseSelectedMarker
    }

    private darkBlueSelectedMarker: string = ""
    public createDarkBlueSelectedMarker(): string {
        if (this.darkBlueSelectedMarker === "") {
            this.darkBlueSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_002C74.svg" + "?" + this.timestamp
        }
        return this.darkBlueSelectedMarker
    }

    private blueSelectedMarker: string = ""
    public createBlueSelectedMarker(): string {
        if (this.blueSelectedMarker === "") {
            this.blueSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_0058B1.svg" + "?" + this.timestamp
        }
        return this.blueSelectedMarker
    }

    private lightBlueSelectedMarker: string = ""
    public createLightBlueSelectedMarker(): string {
        if (this.lightBlueSelectedMarker === "") {
            this.lightBlueSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_008DE3.svg" + "?" + this.timestamp
        }
        return this.lightBlueSelectedMarker
    }

    private greenSelectedMarker: string = ""
    public createGreenSelectedMarker(): string {
        if (this.greenSelectedMarker === "") {
            this.greenSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_056805.svg" + "?" + this.timestamp
        }
        return this.greenSelectedMarker
    }

    private pinkSelectedMarker: string = ""
    public createPinkSelectedMarker(): string {
        if (this.pinkSelectedMarker === "") {
            this.pinkSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_C50084.svg" + "?" + this.timestamp
        }
        return this.pinkSelectedMarker
    }

    private greySelectedMarker: string = ""
    public createGreySelectedMarker(): string {
        if (this.greySelectedMarker === "") {
            this.greySelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_555555.svg" + "?" + this.timestamp
        }
        return this.greySelectedMarker
    }

    private purpleSelectedMarker: string = ""
    public createPurpleSelectedMarker(): string {
        if (this.purpleSelectedMarker === "") {
            this.purpleSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_820084.svg" + "?" + this.timestamp
        }
        return this.purpleSelectedMarker
    }

    private darkBlackSelectedMarker: string = ""
    public createDarkBlackSelectedMarker(): string {
        if (this.darkBlackSelectedMarker === "") {
            this.darkBlackSelectedMarker = this.contentServiceUrl + "/Content/icons/svg/markkeri_korostettu_FFFFFF.svg" + "?" + this.timestamp
        }
        return this.darkBlackSelectedMarker
    }

    private locationMarker: string = ""
    public createLocationMarker(): string {
        if (this.locationMarker === "") {
            this.locationMarker = this.contentServiceUrl + "/Content/icons/svg/location.svg" + "?" + this.timestamp
        }
        return this.locationMarker
    }

    private locateMarker: string = ""
    public createLocateMarker(): string {
        if (this.locateMarker === "") {
            this.locateMarker = this.contentServiceUrl + "/Content/icons/svg/location_v2.svg" + "?" + this.timestamp
        }
        return this.locateMarker
    }

    public createLocationMarkerByColor(color): string {
        if (color != null && color.startsWith("#")) {
            color = color.substring(1, color.length)
        }

        switch (color) {
            case MarkerColors.Blue:
                return this.createBlueMarker()
            case MarkerColors.LightBlue:
                return this.createLightBlueMarker()
            case MarkerColors.DarkBlue:
                return this.createDarkBlueMarker()
            case MarkerColors.Purple:
                return this.createPurpleMarker()
            case MarkerColors.Green:
                return this.createGreenMarker()
            case MarkerColors.Red:
             return this.createRedMarker()
            case MarkerColors.DarkRed:
                return this.createDarkRedMarker()
            case MarkerColors.Turquoise:
                return this.createTurquoiseMarker()
            case MarkerColors.LightTurquoise:
                return this.createLightTurquoiseMarker()
            case MarkerColors.Pink:
                return this.createPinkMarker()
            case MarkerColors.Grey:
                return this.createGreyMarker()
            default:
                return this.createDarkBlackMarker()
        }
    }

    public createSelectedLocationMarkerByColor(color): string {
        if (color != null && color.startsWith("#")) {
            color = color.substring(1, color.length)
        }

        switch (color) {
            case MarkerColors.Blue:
                return this.createBlueSelectedMarker()
            case MarkerColors.LightBlue:
                return this.createLightBlueSelectedMarker()
            case MarkerColors.DarkBlue:
                return this.createDarkBlueSelectedMarker()
            case MarkerColors.Purple:
                return this.createPurpleSelectedMarker()
            case MarkerColors.Green:
                return this.createGreenSelectedMarker()
            case MarkerColors.Red:
                return this.createRedSelectedMarker()
            case MarkerColors.DarkRed:
                return this.createDarkRedSelectedMarker()
            case MarkerColors.Turquoise:
                return this.createTurquoiseSelectedMarker()
            case MarkerColors.LightTurquoise:
                return this.createLightTurquoiseSelectedMarker()
            case MarkerColors.Pink:
                return this.createPinkSelectedMarker()
            case MarkerColors.Grey:
                return this.createGreySelectedMarker()
            default:
                return this.createDarkBlackSelectedMarker()
        }
    }
}
